import {
    getDepositModeConfigValueForKeyWithState,
    getDepositScheduleConfigValueForKeyWithState, getPlanTypesConfigValueForKey,
    getProvincialTaxRateConfigForKey
} from "./ConfigUtil";
import {PLAN_TYPE_IDS, planNameForPlanTypeIDUntranslated, roundHalfUp} from "./PlanUtils";


//Uses the information in the state to determine the cost of the insurance for 1 unit of the given plan
export const calculateCompletionInsurancePerUnitCost = (state, roundTo2Decimals) => {
    let completionInsurancePerUnitCost = 0.0;
    if (state.plan.completionInsurance) {
        if (state.plan.depositMode !== "T") {
            let completionInsuranceTaxRate = getProvincialTaxRateConfigForKey(state.common.signingProvince, 'CompletionInsurance')
            completionInsuranceTaxRate += 1;
            if (state.plan.planTypeID === PLAN_TYPE_IDS.GROUP) {
                completionInsurancePerUnitCost = getDepositScheduleConfigValueForKeyWithState(state, 'CompletionInsuranceAmount');
                completionInsurancePerUnitCost *= completionInsuranceTaxRate;
            } else if (state.plan.planTypeID === PLAN_TYPE_IDS.ACHIEVERS) {
                completionInsurancePerUnitCost = getPlanTypesConfigValueForKey(planNameForPlanTypeIDUntranslated(state.plan.planTypeID), 'CompletionInsuranceAmountPerUnit');
                completionInsurancePerUnitCost *= completionInsuranceTaxRate;
                completionInsurancePerUnitCost = roundHalfUp(completionInsurancePerUnitCost);
                const numberOfDepositsPerYear = getDepositModeConfigValueForKeyWithState(state, 'NumberOfDepositsPerYear');
                completionInsurancePerUnitCost /= (numberOfDepositsPerYear * state.plan.depositCode);
            }
        }
    }
    if (roundTo2Decimals) {
        completionInsurancePerUnitCost = roundHalfUp(completionInsurancePerUnitCost);
    }
    return completionInsurancePerUnitCost;
}

//Uses the information in the state to determine the cost of the insurance for all units of the given plan
export const calculateCompletionInsuranceCostForUnits = (state, roundTo2Decimals) => {
    let ret = calculateCompletionInsurancePerUnitCost(state, false) * state.plan.numberOfUnits;
    if (roundTo2Decimals) {
        ret = roundHalfUp(ret);
    }
    return ret;
}


//Per unit cost of nominee insurance.
//As it turns out, nominee insurance is not per unit - it is fixed amount per year.
export const calculateNomineeInsurancePerUnitCost = (state, roundTo2Decimals) => {
    if (!state.plan.nomineeInsurance) {
        return 0.0;
    }
    if (state.plan.depositMode === 'T') {
        return 0.0; //T Modes have no nominee insurance
    }

    const taxRate = getProvincialTaxRateConfigForKey(state.common.signingProvince, 'NomineeInsurance') + 1;
    let costPerUnit = 0.0;

    if (state.plan.planTypeID === PLAN_TYPE_IDS.GROUP) {
        costPerUnit = getDepositScheduleConfigValueForKeyWithState(state, 'NomineeInsuranceAmount');
        costPerUnit *= taxRate;
    } else if (state.plan.planTypeID === PLAN_TYPE_IDS.ACHIEVERS || state.plan.planTypeID === PLAN_TYPE_IDS.SI) {
        costPerUnit = getPlanTypesConfigValueForKey(planNameForPlanTypeIDUntranslated(state.plan.planTypeID), 'NomineeInsuranceAmountPerYear');
        costPerUnit *= taxRate;
        const numberOfDepositsPerYear = getDepositModeConfigValueForKeyWithState(state, 'NumberOfDepositsPerYear');
        if (numberOfDepositsPerYear > 0) {
            costPerUnit /= numberOfDepositsPerYear;
        }
    }

    if (roundTo2Decimals) {
        costPerUnit = roundHalfUp(costPerUnit);
    }

    return costPerUnit;
}

//Per unit cost of nominee insurance.
//As it turns out, nominee insurance is not per unit - it is fixed amount per year, so this function is redundant
export const calculateNomineeInsuranceCostForUnits = (state, roundTo2Decimals) => {
    let ret = calculateNomineeInsurancePerUnitCost(state, true); // * state.plan.numberOfUnits;
    if (roundTo2Decimals) {
        ret = roundHalfUp(ret);
    }
    return ret;
}


export const calculateCriticalIllnessInsurancePerUnitCost = (state, roundTo2Decimals) => {
    if (!state.plan.criticalIllnessInsurance) {
        return 0.0;
    }
    if (state.plan.depositMode === 'T') {
        return 0.0; //T Modes have no insurance
    }

    const taxRate = getProvincialTaxRateConfigForKey(state.common.signingProvince, 'CriticalIllnessInsurance') + 1;
    let costPerUnit = 0.0;

    if (state.plan.planTypeID === PLAN_TYPE_IDS.GROUP) {
        costPerUnit = getDepositScheduleConfigValueForKeyWithState(state, 'CriticallIllnessInsuranceAmount');
        const deposit = getDepositScheduleConfigValueForKeyWithState(state, "AdditionalDeposit");
        costPerUnit *= deposit;
        costPerUnit *= taxRate;
    } else if (state.plan.planTypeID === PLAN_TYPE_IDS.ACHIEVERS) {
        costPerUnit = getPlanTypesConfigValueForKey(planNameForPlanTypeIDUntranslated(state.plan.planTypeID), 'CriticallIllnessInsuranceAmount');
        let deposit = getDepositModeConfigValueForKeyWithState(state, "NumberOfDepositsPerYear");
        const numberOfDepositsPerYear = getDepositModeConfigValueForKeyWithState(state, 'NumberOfDepositsPerYear');
        deposit /= (numberOfDepositsPerYear * state.plan.depositCode);
        costPerUnit *= deposit;
        costPerUnit *= taxRate;
    }

    if (roundTo2Decimals) {
        costPerUnit = roundHalfUp(costPerUnit);
    }

    return costPerUnit;
}

export const calculateCriticalIllnessInsuranceCostForUnits = (state, roundTo2Decimals) => {
    let ret = calculateCriticalIllnessInsurancePerUnitCost(state, false) * state.plan.numberOfUnits;
    if (roundTo2Decimals) {
        ret = roundHalfUp(ret);
    }
    return ret;
}